/**
 * 提现 容器
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2025, all rights reserved. Essa.cn
 */
import React from 'react';
import { Button, message, Spin,Alert,InputNumber, } from "antd";
import Lang from "@/components/Lang/Lang";
import {isEmpty,symbolMoneyUtil} from '@utils/utils';
import EssaModal from "@/components/EssaModal/EssaModal";
import FnanceAction from "../Fnance.action";
import BankCardSelector from "@/components/BankCardSelector/BankCardSelector";
// import HttpServerAction from '@/api/httpServer.action';
import "./CashOut.less";
class CashOutModal extends React.Component{
    static defaultProps = {
        buyerId:"",//采购商ID
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModal: false,
            // 银行列表
            bankList: []
        }
    }
    onChangeAmount(value){
        this.setState({amount:value})
    }
    changeBank(curBank){
        this.setState({curBank:curBank})
    }
    /**
     * 弹窗
     * */
    openModal(flag,){
        if(!flag){//取消时清空数据
            this.changeBank({});
            this.onChangeAmount(null);
        } else {
            // 打开弹窗时请求银行列表
            // this.getBankList();
        }
        this.setState({
            showModal: flag
        })
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }

    /**
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8536
     * 钱包提现
     */
    handleOk(){
        const {cusModel,} = this.props;
        const {curBank,amount} = this.state;
        if(amount>0&&curBank&&curBank.id){
            const postData = {
                finDdpWalletId: cusModel.id,
                amount: amount,
                buyerBankCardId: curBank.id,
            }
            this.loading(true);
            FnanceAction.cashOut(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
        }else {
            if(!amount){
                message.open({
                    type: 'warning',
                    content: Lang({id: 'QingShuRuTiXianJinE',default:'请输入提现金额'}),
                });
            }else if (!curBank||!curBank.id) {
                message.open({
                    type: 'warning',
                    content: Lang({id: 'XuanZeShouKuanYinXingKa',default:'选择收款银行卡'}),
                });
            }

        }
    }
    handleRes(response={}){
        this.loading(false);
        if (response.success && response.valid) {
            message.open({
                type: 'success',
                content: Lang({id: 'CaoZuoChengGong', default: '操作成功'}),
            });
            //重置内容
            this.openModal(false);
            // 刷新 页面数据
            setTimeout(()=>{
               if(this.props.refreshPage)this.props.refreshPage();
            },200)
        }else if (response.message){
            message.open({
                type: 'info',
                content: response.message,
            });
        }else{
            message.open({
                type: 'warning',
                content: Lang({id: 'CaoZuoShiBai',default:'操作失败'}),
            });
        }
    }
    render(){
        const {buyerId,cusModel={}} = this.props;
        const {loading, showModal, amount=null } = this.state;
        return (<Spin spinning={loading}>
                <Button type="primary" shape="round" className={"btnPay"} ghost onClick={()=>this.openModal(true)}>
                    {Lang({id: "TiXian",default: "提现"})}
                </Button>
                {showModal&&<EssaModal title={Lang({id: "TiXian",default: "提现"})}
                                                open={showModal}
                                                width={600}
                                                onOk={()=>this.handleOk()}
                                                cancelText={Lang({id: "ZanBuTiXian",default: "暂不提现"})}
                                                okText={Lang({id: "TiJiao",default: "提交"})}
                                                onCancel={()=>this.openModal(false)}>
                    <Spin spinning={loading}>
                    <div className={"CashOutWrap"}>
                        <Alert message={Lang({id: "NiTiJiaoDeTiXianShenQingJ",default: "你提交的提现申请，将在财务审核通过后 3 个工作日汇到到账"})}
                               type="info" showIcon className={"payTips"} />
                        <BankCardSelector
                            buyerId={buyerId}
                            changeBank={(v) => this.changeBank(v)}
                        />
                        <div className={"mt_20"}>
                            <span className={"color-red2 mr_4"}>*</span>
                            <span className={"font_16 black89 fw_700"}>{Lang({id: "TiXianJinE",default: "提现金额"})}</span>
                        </div>
                        <div className={"mt_12"}>
                            <InputNumber precision={2} type="number"
                                         placeholder={Lang({id: "QingShuRu",default: "请输入"})}
                                         value={amount}
                                         min={0}
                                         max={cusModel.ddpBalance||0}
                                         onChange={(v)=>this.onChangeAmount(v)}
                                         style={{ width: '100%' }}></InputNumber>
                        </div>
                        <div className={"mt_12"}>
                            {Lang({id: "DangQianQianBaoQuanBuYuE",default: `当前钱包全部余额 ${cusModel.ddpBalance&&symbolMoneyUtil(cusModel.ddpBalance, cusModel.currencySymbol)}`,params:[cusModel.ddpBalance&&symbolMoneyUtil(cusModel.ddpBalance, cusModel.currencySymbol)]})}
                            <span className={"font-main2 ml_12 cursor-p"} onClick={()=>this.onChangeAmount(cusModel.ddpBalance)}>{Lang({id: "QuanBuTiXian",default: "全部提现"})}</span>
                        </div>
                    </div>
                    </Spin>
                </EssaModal>}
            </Spin>
        )
    }
}

export default CashOutModal;
